var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _path2, _rect7, _rect8, _rect9, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoOffers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 76,
    fill: "none",
    viewBox: "0 0 104 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58.524,
    height: 41.592,
    x: 0.976,
    y: 0.811,
    fill: "#fff",
    stroke: "#E2E6EF",
    rx: 4.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.434,
    height: 11.436,
    x: 24.521,
    y: 5.811,
    fill: "#E2E6EF",
    rx: 5.717
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 39.53,
    height: 6.161,
    x: 10.474,
    y: 21.164,
    fill: "#E2E6EF",
    rx: 3.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3291E9",
    d: "M23.0859 34.322C23.0859 32.6207 24.4651 31.2416 26.1664 31.2416H34.3095C36.0108 31.2416 37.39 32.6207 37.39 34.322C37.39 36.0233 36.0108 37.4025 34.3095 37.4025H26.1664C24.4651 37.4025 23.0859 36.0233 23.0859 34.322Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 58.524,
    height: 41.592,
    x: 22.554,
    y: 21.664,
    fill: "#fff",
    stroke: "#E2E6EF",
    rx: 4.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 11.434,
    height: 11.436,
    x: 46.099,
    y: 26.664,
    fill: "#E2E6EF",
    rx: 5.717
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 39.53,
    height: 6.161,
    x: 32.051,
    y: 42.017,
    fill: "#E2E6EF",
    rx: 3.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3291E9",
    d: "M44.6631 55.1749C44.6631 53.4736 46.0423 52.0945 47.7435 52.0945H55.8867C57.588 52.0945 58.9671 53.4736 58.9671 55.1749C58.9671 56.8762 57.588 58.2554 55.8867 58.2554H47.7435C46.0423 58.2554 44.6631 56.8762 44.6631 55.1749Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 58.524,
    height: 41.592,
    x: 44.133,
    y: 33.519,
    fill: "#fff",
    stroke: "#E2E6EF",
    rx: 4.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 11.434,
    height: 11.436,
    x: 67.678,
    y: 38.519,
    fill: "#E2E6EF",
    rx: 5.717
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 39.53,
    height: 6.161,
    x: 53.63,
    y: 53.872,
    fill: "#E2E6EF",
    rx: 3.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3291E9",
    d: "M66.2422 67.0304C66.2422 65.3291 67.6214 63.95 69.3226 63.95H77.4658C79.1671 63.95 80.5462 65.3291 80.5462 67.0304C80.5462 68.7317 79.1671 70.1109 77.4658 70.1109H69.3226C67.6214 70.1109 66.2422 68.7317 66.2422 67.0304Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOffers);
export default __webpack_public_path__ + "static/media/NoOffers.7763716334f5025f7f4a78996271fba8.svg";
export { ForwardRef as ReactComponent };